/* eslint-disable no-unused-vars */
export enum clubMemberType {
  Archived = "archived",
  Member = "MEMBERS",
  NonMember = "NON-MEMBERS",
}

export enum EventType {
  AdvanceBooking = "advance-booking",
  Booking = "booking",
  Blocking = "blocking",
  CampTournament = "camp_tournament",
  Maintenance = "maintenance",
  Restriction = "restriction",
  Exception = "exception",
  Unavailable = "unavailable",
  Training = "training",
  TempBooking = "temp-booking",
}

export enum EventSubType {
  QuotaExhausted = "quota-exhausted",
  AdvanceBooking = "advance-booking",
}

export enum EventBackgroundType {
  Block = "block",
  Background = "background",
}

export enum BOOKING_DRAWER_STEPS {
  ONE = 1,
  TWO = 2,
}
